import React from 'react';
import { connect } from 'react-redux';

import { SessionServerSelectors, SessionSiteSelectors, SessionUserSelectors } from '~selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~selectors/SiteUrlsSelectors';
import { NavLocationSelectors } from '~src/spacesPlatform/selectors/NavigationStateSelectors';

import { AppState } from '../../../app/state/AppState';
import { MapStateToProps } from '../../../app/utils/ConnectUtils';
import { selectCatalogingOnSiteEnabled } from '../../../catalog/selectors/CatalogSelectors';
import { NavPanel, NavPanelOwnProps, NavPanelStateProps } from './NavPanel';

const mapStateToProps: MapStateToProps<NavPanelStateProps> = (state: AppState) => ({
  siteUrls: siteUrlsSelector(state),
  spaceType: state.spaceInfo.spaceType,
  currentNavLocation: NavLocationSelectors.selectNavLocation(state),
  inServerArea: NavLocationSelectors.inServerArea(state),
  isSessionSiteAdmin: SessionSiteSelectors.isSessionSiteAdmin(state),
  isSessionServerAdmin: SessionUserSelectors.isSessionServerAdmin(state),
  isSessionMultiSite: SessionUserSelectors.isSessionMultiSite(state),
  isSiteAdminSettingsEnabled: SessionServerSelectors.isSiteAdminSettingsEnabled(state),
  isAdminViewsEnabled: SessionServerSelectors.isAdminViewsEnabled(state),
  isCatalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  isNamedSharingEnabled: SessionSiteSelectors.isNamedSharingEnabled(state),
  isVizRecommendationsEnabled: SessionSiteSelectors.isVizRecommendationsEnabled(state),
  shouldShowPersonalSpace: SessionSiteSelectors.shouldShowPersonalSpace(state),
  isSitePickerEnabled: SessionServerSelectors.sitePickerEnabled(state)
});

export const ConnectedNavPanel: React.ComponentClass<NavPanelOwnProps> =
  connect(mapStateToProps)(NavPanel);
